/**
 * <sun-product-availability>
 * Toggle `.variant--soldout` sur `.sun-product__panel` au changement de
 * variant ou de quantité. Source de vérité: `[data-selected-variant]` JSON
 * cross-check avec la valeur de `input[name="quantity"]`.
 */
class SunProductAvailability extends HTMLElement {
  connectedCallback() {
    this.panel = this.closest('.sun-product__panel');
    this.productInfo = this.closest('product-info');
    if (!this.panel || !this.productInfo) return;

    this.sync();

    this.loadHandler = (event) => {
      if (event.target !== this.productInfo) return;
      this.sync();
    };
    document.addEventListener('theme:product-info:loaded', this.loadHandler);

    this.variantSelects = this.productInfo.querySelector('variant-selects');
    if (this.variantSelects) {
      this.changeHandler = () => requestAnimationFrame(() => this.sync());
      this.variantSelects.addEventListener('change', this.changeHandler);
    }

    this.qtyChangeHandler = (event) => {
      if (event.target && event.target.matches && event.target.matches('input[name="quantity"]')) {
        requestAnimationFrame(() => this.sync());
      }
    };
    this.productInfo.addEventListener('change', this.qtyChangeHandler);
  }

  disconnectedCallback() {
    document.removeEventListener('theme:product-info:loaded', this.loadHandler);
    if (this.variantSelects && this.changeHandler) {
      this.variantSelects.removeEventListener('change', this.changeHandler);
    }
    if (this.qtyChangeHandler) {
      this.productInfo.removeEventListener('change', this.qtyChangeHandler);
    }
  }

  sync() {
    const script = this.productInfo.querySelector('[data-selected-variant]');
    if (!script) return;

    let variant = null;
    try {
      variant = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }

    let unavailable = !variant || variant.available === false;

    if (!unavailable && variant) {
      const rule = variant.quantity_rule || {};
      const min = rule.min || 1;
      const inventoryManagement = variant.inventory_management;
      const inventoryPolicy = variant.inventory_policy;
      const inventoryQuantity = variant.inventory_quantity;
      const checkAgainstInventory = inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';

      if (checkAgainstInventory) {
        // Variant-level min rule
        if (min > inventoryQuantity) {
          unavailable = true;
        }
        // Current form quantity vs inventory (catches L'UNITÉ vs LA PAIRE)
        const qtyInput = this.productInfo.querySelector('input[name="quantity"]');
        if (qtyInput) {
          const qty = parseInt(qtyInput.value, 10) || 1;
          if (qty > inventoryQuantity) {
            unavailable = true;
          }
        }
      }
    }

    this.panel.classList.toggle('variant--soldout', unavailable);
  }
}

if (!customElements.get('sun-product-availability')) {
  customElements.define('sun-product-availability', SunProductAvailability);
}
